export default __webpack_public_path__ + "static/media/Sri.76e9aea0.png";